import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { ModalWithStyles } from './ModalWithStyles';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import { useSnackbarWithStyles } from '../../components/notifications/SnackbarProviderWithStyles';

export function RefundProratedChargeModal(props) {
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();

  return (
    <ModalWithStyles
      onSubmit={async () => {
        const response = await props.mutation.mutateAsync({
          endpoint: endpointEnum.REFUND_STRIPE_CHARGE_BY_CHARGE_ID,
          payload: {
            call: methodNameEnum.REFUND_STRIPE_CHARGE_BY_CHARGE_ID,
            chargeid: props.chargeid,
          },
        });

        // console.log(response.data)
        if (response?.data?.success) {
          enqueueSnackbarWithStyles({
            message: 'Refund succeeded!',
            alertProps: {
              severity: 'success',
            },
          });
        } else {
          if (response?.data?.result === 'charge_already_refunded') {
            enqueueSnackbarWithStyles({
              message: 'Charge has already been refunded.',
              alertProps: {
                severity: 'error',
              },
            });
          } else {
            enqueueSnackbarWithStyles({
              message: 'Refund failed, please try again later.',
              alertProps: {
                severity: 'error',
              },
            });
          }
        }

        props.handleClose();
        props.setRefetchToggleForStripeLoadable({});
      }}
      title={`Refund Prorated Charge (invoice ID: ${props.invoiceid})`}
      aria-labelledby="example-modal-sizes-title-md"
      show={props.show}
      onHide={props.handleClose}
      submitLabel="Refund"
    >
      <br />
      <center>
        <p>
          You are about to refund <b>${props.amount}</b> to{' '}
          <b>BID {props.businessid}</b>, this procedure is <b>not reversible</b>
          .
        </p>
        <p>Do you want to proceed?</p>
      </center>
      <br />
    </ModalWithStyles>
  );
}
